// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1029) return "static/chunks/1029-aa0eba64c9467896.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1552 ? "c24d9160" : chunkId) + "." + {"1552":"1d889b958e88d74d","2543":"ff3cbeb90edf8447","3796":"6c251d3157eaf995","4924":"accac27437ecfee6","4959":"46971a86e2fe500a","5970":"fb4e9d56408455e1","5987":"bdb6867af5bc730c","7732":"ab406326b92bc9ff","7926":"363ac677be547983"}[chunkId] + ".js";
};